import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

export function initDataDogLogs() {
  datadogLogs.init({
    clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN,
    site: 'us5.datadoghq.com',
    service: 'vsms2-fe',
    host: window.location.hostname,
    env: process.env.VUE_APP_ENV,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

export function initDataDogRum(config) {
  datadogRum.init(config)
}
